module.exports = __webpack_public_path__ + "img/logo-dark.4131a853.png";